<mat-form-field
  appearance="outline"
  class="wideInput"
  [ngClass]="{ 'error-border': customErrorMessage }"
>
  <mat-label [ngClass]="{ 'error-text': customErrorMessage }">
    {{ label }}
  </mat-label>

  <mat-select
    id="name"
    [required]="isRequired"
    errorState="selectField.hasError('required')"
    [formControl]="selectField"
    [multiple]="multipleSelect"
    (selectionChange)="handleSelectionChange($event)"
  >
  <div class="select-option">
    <mat-option *ngFor="let option of options" value="{{ option.id }}">
      {{ option.value }}
    </mat-option>
    </div>
    @if(multipleSelect && selectField.value && selectField.value.length > 0){
    <mat-select-trigger>
      <mat-chip-set>
        <mat-chip-row
          *ngFor="let option of toArray(selectField.value)"
          [removable]="true"
          (removed)="removeOption(option)"
        >
          {{ getOptionValueById(option) }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      </mat-chip-set>
    </mat-select-trigger>
    }
  </mat-select>

  <mat-error *ngIf="customErrorMessage">
    {{ customErrorMessage }}
  </mat-error>
</mat-form-field>
